import 'angular:locale/data:en';
import 'angular:locale/data:el';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
